import React from 'react'
import {useSelector} from 'react-redux'
import {useTranslation} from 'react-i18next'

import './index.less'
import './mobile.less'
import Layout from '@/components/Layout'
import ContentHeader from '@/components/ContentHeader'
import GetInTouch from '@/components/GetInTouch'
import GoogleMaps from '@/components/GoogleMaps'
import WechatPopover from '@/components/WechatPopover'

import warehouse1 from '@/assets/img/contactUs/warehouse1.png'
import warehouse2 from '@/assets/img/contactUs/warehouse2.png'
import warehouse3 from '@/assets/img/contactUs/warehouse3.png'
import warehouse4 from '@/assets/img/contactUs/warehouse4.png'

export default function AboutUs() {
  const {t} = useTranslation()

  const commonState = useSelector(state => state.common)
  const rootClassName = commonState.isMobile ? 'contact-us-mobile-container' : 'contact-us-container'

  return (
    <Layout isShowFooterTop={false}>
      <div className={rootClassName}>
        {/* <ContentHeader
          className={'contact-us-header-container'}
          des={t('About us')}
          title={t('Our Brand')}
          banner={bannerImg}
        /> */}
        <div className={'contact-us-content-container'}>
          <div className={'contact-us-content-left-container'}>
            <img src={warehouse1} />
            <img src={warehouse2} />
          </div>
          <div className={'contact-us-content-left-container'}>
            <img src={warehouse3} />
            <img src={warehouse4} />
          </div>
          <div className={'contact-us-content-right-container'}>
            <div className={'contact-us-content-right-working-hours-container'}>
              <div className={'contact-us-content-right-title'}>{t('Company Information')}</div>
              <div className={'contact-us-content-right-working-hours-item-container'}>
                <span>{t('Apoodr Inc’s parent company has been in business since 1965, specializing in the import of Apoodr inc products and has a long, established history of customer satisfaction with competitive prices, quality, and customer service. We strive to excel in customer service. Products are purchased in Asia and the Orient but our offices are located in northern, central and southern California, with strategically placed stores and warehouses to help ensure product freshness. Satisfied customers include DeCA (Defense Commissary Agency), food distributors, food brokers, food wholesalers, supermarkets and restaurants. Through this website, you too may be our customer. Welcome!')}</span>
              </div>
              <div className={'contact-us-content-right-working-hours-item-container'}>
                <span>{t("Address: 2110 Edwards Ave, South El Monte CA91733")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
